var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { UserService } from "../../services/user.service";
import { PromotionalAdsService } from "../../services/promotional-ads.service";
import { EduComponent } from "../../utils/eduComponent";
var PromotionalAdsComponent = /** @class */ (function (_super) {
    __extends(PromotionalAdsComponent, _super);
    function PromotionalAdsComponent(userService, promotionalAdsService) {
        var _this = _super.call(this) || this;
        _this.userService = userService;
        _this.promotionalAdsService = promotionalAdsService;
        _this.promotionalAds = [];
        _this.subscriptions = [];
        _this.gtmPromoItemImageClass = "gtm-homepage-promo-item-image";
        _this.gtmPromoItemCallToActionClass = "gtm-homepage-promo-item-call-to-action-text";
        return _this;
    }
    PromotionalAdsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.promotionalAdsService.getAds().subscribe(function (promos) {
            _this.promotionalAds = promos.ads.sort(function (a, b) {
                return a.spot - b.spot;
            });
        }));
    };
    return PromotionalAdsComponent;
}(EduComponent));
export { PromotionalAdsComponent };
